var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"markdown-wrap"}},[_c('div',{attrs:{"id":_vm.randomID}}),(_vm.jsLoading)?_c('beat-loader',{attrs:{"color":'#37cbf1',"num":7,"size":10}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }